// extracted by mini-css-extract-plugin
module.exports = {"map":"ObjectsMap_map__bgAtq","loading":"ObjectsMap_loading__3ndub"};